// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: {
    margin: [15, 15, 0],
    width: "calc(100% - 30px)",
  },
  subtitle: {
    color: "#9F9F9F",
    margin: [0, 15, 25],
    width: "calc(100% - 30px)",
  },
  grow: {
    "flex-grow": 1,
  },
  options: {
    width: "100%",
    "max-width": 500,
    "min-height": "calc(100% - 75px)",
    position: "relative",
    "padding-bottom": 50,
    margin: [0, "auto"],

    "& hr": {
      width: "100%",
      "margin-top": 15,
      color: "#808080",
      "box-sizing": "border-box",
    },
  },
  legacy: {
    width: "calc(100% - 30px)",
    margin: [15, 30],
    cursor: "pointer",

    "&:hover": { color: "#9F9F9F" },
  },
  info: {
    width: "100%",
    height: "100%",
    position: "relative",

    "& p": {
      "max-width": 500,
    },
  },
  showcase: {
    width: "100%",
    "border-radius": 8,
    background: "#252525",
  },
  genericSelector: {
    "margin-top": 5,
    width: "100%",
    "& div": {
      height: 50,
      width: 50,
      "margin-right": 15,
      border: "1px solid #707070",
      "border-radius": 3,
      "background-size": "cover",
      float: "left",
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
    },
    "& p": { margin: [2, 0] },
    "& button": {
      "background-color": "#252525",
      border: "none",
      color: "white",
      "border-radius": 5,
      cursor: "pointer",
      padding: [5, 15],
      width: "max-content",
    },
  },
};
